import { render, staticRenderFns } from "./asset-type-files.vue?vue&type=template&id=0552f816&scoped=true&"
import script from "./asset-type-files.vue?vue&type=script&lang=js&"
export * from "./asset-type-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552f816",
  null
  
)

export default component.exports